<template>
    <footer
        class="o-footer"
        :style="{marginBottom: `${marginBottom}px`}"
    >
        <div class="l-container">
            <div class="l-row">
                <div class="l-row__column">
                    <figure class="a-image">
                        <img class="o-footer__logo" src="@/assets/logo.png" alt="">
                    </figure>
                    <p class="o-footer__text">Administratorem danych osobowych jest TAKE A FRUIT Sp. z o.o., ul. Twarda 18, 00-105 Warszawa<br />
                        NIP: 701-032-72-90; REGON: 145906171
                    </p>
                    <p class="o-footer__text">v{{ version }}</p>
                    <br />
                    <p class="o-footer__text">
                        <a
                            :href="getUrl('start')"
                            class="o-footer__link"
                        >Strona główna</a> |
                        <a
                            :href="offerMode ? getUrl('offer-regulations') : getUrl('regulations')"
                            class="o-footer__link"
                        >Regulamin</a> |
                        <a
                            :href="getUrl('privacy')"
                            class="o-footer__link"
                        >Polityka Prywatności</a> |
                        Created by
                        <a
                            href="https://x-one.pl"
                            class="o-footer__link"
                            target=_blank
                        >x-one</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="l-container o-ueBar">
            <div class="l-row">
                <div class="l-row__column o-ueBar__desktop">
                    <a
                        href="https://takeafruit.pl/blog/inwestycje-w-przedsiebiorstwie-take-a-fruit/"
                        target=_blank
                    >
                        <figure class="a-image o-ueBar__logos">
                            <img class="o-footer__logo" src="@/assets/footer.png" alt="">
                        </figure>
                    </a>
                </div>
                <div class="l-row__column o-ueBar__mobile">
                    <a
                        href="https://takeafruit.pl/blog/inwestycje-w-przedsiebiorstwie-take-a-fruit/"
                        target=_blank
                    >
                        <figure class="a-image o-ueBar__logos">
                            <img class="o-footer__logo" src="@/assets/footer.png" alt="">
                        </figure>
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            marginBottom: 0
        }
    },
    watch: {
        $route(to, from) {
            const mobileButtons = document.getElementsByClassName('a-mobile__buttons')
            this.marginBottom = mobileButtons.length > 0 ? mobileButtons[0].offsetHeight : 0
        }
    },
    computed: {
        version() {
            return process.env.PACKAGE_VERSION
        },
        offerMode() {
            return this.$route.meta.offerMode
        }
    },
    methods: {
        getUrl(route) {
            return this.$router.resolve({
                name: route
            }).route.path
        }
    }
}
</script>
